module.exports = __webpack_public_path__ + "img/vp_1.8d3ba480.png";